import type { Scheduling, SellingMode, TariffGroupAttribute } from '@src/core/buyerApiClient';
import type { TariffsState } from '@src/stores/product';

import { applyTariffsForDateAndAttributes } from '@src/domains/tariffs/core/applyTariffsForDateAndAttributes';
import { LANGUAGE_ATTRIBUTE_TYPE } from '@src/domains/products/features/product-booking/types/attribute';

export const applyTariffsForDateAndLanguage = (
  sellingMode: SellingMode,
  tariffsState: TariffsState,
  schedulings: Scheduling[],
  attributes: TariffGroupAttribute[],
  selectedLanguage: string | null,
  minSaleTariffQuantities: number,
): void =>
  applyTariffsForDateAndAttributes(
    sellingMode,
    tariffsState,
    schedulings,
    attributes,
    selectedLanguage?.trim() ? [{ type: LANGUAGE_ATTRIBUTE_TYPE, value: selectedLanguage }] : [],
    minSaleTariffQuantities,
  );
